import { API_BASE_URL } from '../config';

export type AdminAccountRow = {
  emailaddress: string;
  name: string;
  contactnumber: string;
};

export type AdminRegistrationResponse = AdminAccountRow & {
  password: string;
};

export async function fetchAdminList(): Promise<AdminAccountRow[]> {
  const res = await fetch(`${API_BASE_URL}/api/admins`);
  if (!res.ok) {
    throw new Error('Failed to load admin list');
  }
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function createAdmin(body: {
  name: string;
  emailaddress: string;
  contactnumber: string;
}): Promise<AdminRegistrationResponse> {
  const res = await fetch(`${API_BASE_URL}/api/admins`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (res.status === 409) {
    throw new Error('EMAIL_EXISTS');
  }
  if (!res.ok) {
    throw new Error('CREATE_FAILED');
  }
  return res.json();
}

export async function updateAdmin(
  email: string,
  body: { name: string; contactnumber: string }
): Promise<AdminAccountRow> {
  const res = await fetch(`${API_BASE_URL}/api/admins/${encodeURIComponent(email)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new Error('UPDATE_FAILED');
  }
  return res.json();
}

export async function deleteAdmin(email: string): Promise<void> {
  const res = await fetch(`${API_BASE_URL}/api/admins/${encodeURIComponent(email)}`, {
    method: 'DELETE',
  });
  if (!res.ok && res.status !== 204) {
    throw new Error('DELETE_FAILED');
  }
}

export async function resetAdminPassword(email: string): Promise<string> {
  const res = await fetch(`${API_BASE_URL}/api/admins/${encodeURIComponent(email)}/reset-password`, {
    method: 'POST',
  });
  if (!res.ok) {
    throw new Error('RESET_FAILED');
  }
  const data = await res.json();
  return typeof data?.password === 'string' ? data.password : '';
}
